"use client"
import { GetPageQuery } from "apollo"
import { BlockRenderer } from "ui"
import { Culture, findProperty } from "utils"
import Header from "./Newsroom/Header"
import MainNews from "./Newsroom/MainNews"
import MediaContact from "./Newsroom/MediaContact"
import MoreNews from "./Newsroom/MoreNews"

type Props = {
  data: GetPageQuery
  culture: Culture
  locale: string
}

function Newsroom({ data, culture, locale }: Props) {
  const components = {
    tierraBonitaNewsroomHeader: Header,
    tierraBonitaNewsroomMainNews: MainNews,
    tierraBonitaNews: MoreNews,
    tierraBonitaMediaContact: MediaContact,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  return (
    <>
      {blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              culture={culture}
              locale={locale}
              props={{ biggerBorder: index === 1 }}
            />
          )
        },
      )}
    </>
  )
}

export default Newsroom
